const formatIncomeExpenseValue = (value) => {
  if (typeof value === 'string') return parseFloat(value.replace(',', ''));

  return value;
};

export default formatIncomeExpenseValue;
